// DocumentsZone — français. « Open », « Loading… » et « not collected » vivent dans common.fr.ts
// et ne sont pas répétés ici. Les noms de cellules viennent du raster via `labelFor`.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Documents': 'Documents',
  'the PDFs a profile run read and kept, with the cells that rest on them':
    'les PDF qu’une recherche de profil a lus et conservés, avec les cellules qui s’y appuient',

  // the columns
  'Year': 'Année',
  'Source': 'Source',
  'Fetched': 'Récupéré',
  'Size': 'Taille',
  'Cited by': 'Cité par',
  '{n} bytes': '{n} octets',
  'Open the kept PDF as the run read it': 'Ouvrir le PDF conservé tel que la recherche l’a lu',
  'no cell cites it': 'aucune cellule ne le cite',

  // the states
  'This server does not report kept documents yet. A profile run keeps the annual report it reads; once the record answers with its documents they are listed here.':
    'Ce serveur ne signale pas encore de documents conservés. Une recherche de profil conserve le rapport annuel qu’elle lit ; dès que le dossier annonce ses documents, ils figurent ici.',
  'No document is kept for this organisation. A profile fill that finds an annual report reads the PDF in the same run and keeps it here, beside the cells it filled.':
    'Aucun document n’est conservé pour cette organisation. Une recherche de profil qui trouve un rapport annuel lit le PDF dans la même passe et le conserve ici, à côté des cellules qu’elle a remplies.',
}, 'DocumentsZone');
